import TableCellRenderer from '../../../table/TableCellRenderer'
import messageResource from '../../../messageResource'
import _ from 'underscore'

function EffectiveDateCellRenderer()
{}

EffectiveDateCellRenderer.prototype = _.create(TableCellRenderer.prototype);

EffectiveDateCellRenderer.prototype.init = function( invertedDays, weekStartDay, changesCallback, prefix, scrollableContainer, corporateSchedule )
{
    TableCellRenderer.call( this );
    this.invertedDays = invertedDays;
    this.weekStartDay = weekStartDay;
    this.changesCallback = changesCallback;
    this.prefix = prefix;
    this.scrollableContainer = scrollableContainer;
    this.corporateSchedule = corporateSchedule;
    return this;
};


EffectiveDateCellRenderer.prototype.generateContent = function( cell )
{
    cell.getCellEl().innerHTML = 
    "<table class='caption' cellpadding=0 cellspacing=0 border=0><tbody><tr><td>" + 
        this.prefix + 
    "</td><td></td><td>:</td></tr></tbody></table>" +
    "<div class ='current'>" +
        messageResource.getMessage("user.add_edit.js.wd_editor.working_schedule_current") +
    "</div>";

    var self = this;

    var dateSelector = window.ClassicBridge.integrateCalendar(cell.getCellEl().firstChild.firstChild.firstChild.firstChild.nextSibling, {
        selectedDay: cell.getValue(),
        type: 'day',
        placeholder: !cell.getValue() && messageResource.getMessage("common.date_selector.select_date"),
        onSelect: (date) => {
            cell.setValue(Date.parseJSONDate(date));
            cell.updateUI();
            dateSelector.setProps({ selectedDay: Date.parseJSONDate(date), placeholder: "" });
            self.changesCallback();
        },
        compactDate: true
    })

    cell.dateSelector = dateSelector
};

EffectiveDateCellRenderer.prototype.getCellClassName = function( cell )
{
    var classes = ["effectiveDateCell", "atNextMount"];
    if( !cell.isValid() ) {
        classes.push("invalid");
        cell.dateSelector.setProps({ triggerClassName: "dateError" });
    } else {
        cell.dateSelector.setProps({ triggerClassName: "" });
    }
    return classes;
};

EffectiveDateCellRenderer.prototype.updateUI = function( cell )
{
    TableCellRenderer.prototype.updateUI.call( this, cell );
    cell.dateSelector.setProps({ disabled: cell.getRow().isMarkedToRemove() });
};

export default EffectiveDateCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/EffectiveDateCellRenderer.js